export enum ModuleType {
  related_article = 'related_article',
  category_related_post = 'category_related_post',
  related_hashtag = 'related_hashtag',
  related_topic = 'related_topic',
  related_user = 'related_user',
  kep_breadcrumbs = 'kep_breadcrumbs',
  author_related_article = 'author_related_article',
  hashtag_related_article = 'hashtag_related_article',
  activity_banner = 'activity_banner',
  lemon8_banner = 'lemon8_banner',
  comment = 'comment',
  comment_modal = 'comment_modal',
  main_sar = 'main_sar',
  main_content = 'main_content',
  main_related_post = 'main_related_post',
  gallery_img_mask = 'gallery_img_mask',
  user_homepage_info = 'user_homepage_info',
  co_creator = 'co_creator',
  // pc reflow qrcode
  scan_code = 'scan_code',
  related_search = 'related_search',
  bottom_sar_search = 'bottom_sar_search',
  // experience
  experience_content = 'experience_content',
  experience_post = 'experience_post',
  experience_related_post = 'experience_related_post',
  // experience post modal - related article
  experience_related_article = 'experience_related_article',
  experience_related_topic = 'experience_related_topic',
  // kep
  kep_question_answer = 'kep_question_answer',
}
